// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"nQ-z","smallCardRow":"oQ-z","largeCardRow":"pQ-z","productSearchRow":"qQ-z","curatedRow":"rQ-z"};